var _defs, _path, _path2, _path3, _g, _path4, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "1.2 2.97 61.6 61.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lp",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffdf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8dfc4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rp",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8dfc4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffdf5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tp",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ece4cb"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18 L2 52 Q16 50 32 56 Q48 50 62 52 L62 18 Z",
    fill: "#3c6aa8",
    stroke: "#284c7c",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14 Q18 12 32 18 L32 53 Q18 47 5 49Z",
    fill: "url(#lp)",
    stroke: "#b3a682",
    strokeWidth: 0.9
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59 14 Q46 12 32 18 L32 53 Q46 47 59 49Z",
    fill: "url(#rp)",
    stroke: "#b3a682",
    strokeWidth: 0.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#cfc6aa",
    strokeWidth: 0.8,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0 25.4 Q46.0 20.2 56.0 21.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0 28.9 Q46.0 23.9 56.0 25.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0 32.4 Q46.0 27.5 56.0 28.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0 35.9 Q46.0 31.2 56.0 32.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0 39.4 Q46.0 34.8 56.0 35.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0 42.9 Q46.0 38.5 56.0 39.0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 18 Q23 9.5 13 10 Q12 29 16 46 Q25 47.5 32 53Z",
    fill: "url(#tp)",
    stroke: "#b3a682",
    strokeWidth: 0.9,
    strokeLinejoin: "miter"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#cfc6aa",
    strokeWidth: 0.8,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5 25.6 Q22.8 19.4 16.5 19.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 28.9 Q23.0 23.2 16.8 22.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 32.3 Q23.1 27.0 17.1 26.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 35.6 Q23.3 30.7 17.3 29.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 38.9 Q23.5 34.5 17.6 33.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 42.2 Q23.6 38.3 17.9 36.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibrary);
export default __webpack_public_path__ + "static/media/library.1456566c78976dfeaef762e07b57c607.svg";
export { ForwardRef as ReactComponent };